var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M22.688 6.444h-1.342v-1.5H2.017v1.5H.675c-.372 0-.675.309-.675.69 0 .38.303.69.675.69h1.342v7.622c0 .851.337 1.627.886 2.176.547.56 1.295.916 2.127.916h13.293c.832 0 1.59-.356 2.138-.916.548-.55.885-1.325.885-2.176V7.824h1.342c.373 0 .675-.31.675-.69 0-.381-.302-.69-.675-.69",
    transform: "translate(.92 .43)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M11.676 3.705h9.67v-.312c0-.42-.169-.808-.443-1.088-.273-.28-.653-.453-1.064-.453h-5.824c-.106-.43-.327-.818-.632-1.12v-.01C12.94.28 12.34 0 11.676 0c-.663 0-1.263.28-1.706.722v.01c-.295.302-.516.69-.632 1.12H3.524c-.411 0-.79.173-1.064.453s-.443.668-.443 1.088v.312h9.66z",
    transform: "translate(.92 .43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.bb0e544d0070ce9dd0a741a34bcd5420.svg";
export { ForwardRef as ReactComponent };